import { Download } from 'lucide-react';
import { getQuestionSetSampleFileUrl } from '@/services/apiClient';

const FORMATS = [
    { key: 'xlsx', label: 'Excel (.xlsx)', hint: 'Fill in a spreadsheet' },
    { key: 'txt',  label: 'Text (.txt)',   hint: 'Block format for direct upload' },
    { key: 'pdf',  label: 'PDF',           hint: 'Read-only reference' },
];

const FILE_NAMES = { xlsx: 'echohire-sample.xlsx', txt: 'echohire-sample.txt', pdf: 'echohire-sample.pdf' };

/**
 * Three download buttons for the sample question-set file.
 * Props:
 *   label  string  — prefix text (default: "Download sample:")
 *   size   'sm'|'xs'  — button sizing (default: 'sm')
 */
export function SampleDownloadButtons({ label = 'Download sample:', size = 'sm' }) {
    const btnCls = size === 'xs'
        ? 'inline-flex items-center gap-1 rounded-md border border-border bg-muted/50 px-2 py-1 text-[10px] font-medium text-foreground hover:bg-muted transition-colors'
        : 'inline-flex items-center gap-1.5 rounded-md border border-border bg-muted/50 px-2.5 py-1.5 text-xs font-medium text-foreground hover:bg-muted transition-colors';

    return (
        <div className="flex flex-wrap items-center gap-2">
            {label && (
                <span className={size === 'xs' ? 'text-[10px] text-muted-foreground' : 'text-xs text-muted-foreground'}>
                    {label}
                </span>
            )}
            {FORMATS.map(f => (
                <a
                    key={f.key}
                    href={getQuestionSetSampleFileUrl(f.key)}
                    download={FILE_NAMES[f.key]}
                    title={f.hint}
                    className={btnCls}
                >
                    <Download className={size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
                    {f.label}
                </a>
            ))}
        </div>
    );
}

export default SampleDownloadButtons;
